import { styled } from '@/stitches.config';
import { Box, Button } from '@base-app';

import SequenceGoal from '../SequenceGoal';

export const StyledYearlySequenceGoalCard = styled(Box, {
  display: 'flex',
  padding: '$6 $8',
});

export const StyledSequenceGoal = styled(SequenceGoal, {
  display: 'flex',
  flexGrow: '2',
});

export const StyledButton = styled(Button, {
  width: '130px',
});

export const StyledButtonContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'center',
  margin: '$4 0 $6 0',
});
